module.exports = __webpack_public_path__ + "img/tablet-neck-1_28x138.390e6552.png";